document.addEventListener('click', function (e) {

  if (!e.target.classList.contains('footer_heading')) {
    return;
  }

  const clickedItem = e.target.closest('.footer_item_container');

  const activeItem = document.querySelector('.footer_item_container.active');

  if (activeItem && activeItem !== clickedItem) {
    activeItem.classList.remove('active');
  }

  clickedItem.classList.toggle('active');

});
